import { useState, useEffect } from 'react';

// Define the type for fallback images
interface FallbackImagesProps {
  name: string;
  path: string;
  files: any[];
}
const useResFallbackImages = () => {
  const [resFallbackImages, setResFallbackImages] = useState<FallbackImagesProps[]>([]);
  useEffect(() => {
    const fetchFallbackImages = async () => {
      try {
        const response = await fetch(`/hub/services/fallbackImage`);
        const data = await response.json();
        setResFallbackImages(data?.body);
      } catch (error) {
        console.error('Error fetching fallback images:', error);
      }
    };
    fetchFallbackImages();
  }, []);
  return resFallbackImages;
};
export default useResFallbackImages;